export default __webpack_public_path__ + "static/media/symbole-du-dollar.01303f1d.svg";